import React from 'react'
import NavigationFooter from './NavigationFooter'

export function setFiledError(component, failedFields) {
  const { formErrors } = component.state
  component.setState({
    formErrors: {
      ...formErrors,
      ...failedFields,
    },
  })
  component.setState({
    formValidated: true,
  })
}

/** @deprecated This component should be deleted. Logic should be simplified and moved within component. */
export default function Navigation(payload) {
  const { props, component, validationSchema, hidePrev, nextCallback, disabled = false } = payload

  const validateForm = async () => {
    if (nextCallback) {
      if (await nextCallback()) {
        return
      }
    }

    if (!validationSchema) {
      props.next()
      return
    }

    const formError = validationSchema.validate(props.state)
    const failedFields = {}

    if (!formError.error) {
      props.next()
      return
    }

    formError.error.details.forEach((err) => {
      failedFields[err.context.key] = err
    })

    setFiledError(component, failedFields)
  }

  return <NavigationFooter {...props} onPressNext={validateForm} />
}
